import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { API_URL, isFieldError } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Select from "../components/Select";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

import Left from "./Left";
import Right from "../Donate/Right";

import "../Donate/styles.css";

const Guess = () => {
	const [details, setDetails] = useState({
		links: [],
		players: [],
	});
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const query = new URLSearchParams(useLocation().search);
	const formElement = useRef(null);

	useEffect(() => {
		init(query.get("code") || "");

		// eslint-disable-next-line
	}, []);

	const init = async (code) => {
		const url = new URL(`${API_URL}/guessInit`);
		const params = {
			code,
			open: query.get("open") ? "1" : "0",
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setNames({ code, donationId: json.donationId });
				setDetails({ ...json });
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/guess`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setAlert({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column" style={{ minHeight: "100%" }}>
			<Hdg section="Guess the Champion Contest" />
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<div className="donate-charity-box">
						<div>
							<Left charity={details.charity} />
							<Right
								data={{
									logo: details.logo,
									charity: details.charity,
									links: details.links,
								}}
							/>
						</div>

						<form
							ref={formElement}
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
						>
							<h3 style={{ marginTop: "0" }}>Guess the 2026 Champion</h3>
							<p>
								Select the player as your guess provided by the drop down list
								down below.
							</p>

							<div className="form-group">
								<Select
									name="player"
									label="Select Player"
									reqd={true}
									value={""}
									options={[{ id: "", name: "--" }].concat(details.players)}
									update={handleUpdate}
									error={isFieldError(errors, "player")}
								/>
								<div className="empty" />
							</div>

							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit submit="Submit Guess" />
								</div>
							</div>
						</form>
					</div>
				</>
			)}
		</div>
	);
};

export default Guess;
